import { Inject, Injectable } from '@angular/core';
import { TOrganizi8EnvironmentVars } from '@monorepo/types';

const Organizi8Endpoints = {
  GET_FABRIC_CREATE_GRN_LOT_LISTING: 'GET_FABRIC_CREATE_GRN_LOT_LISTING',
  GET_TRIMS_CREATE_GRN_LOT_LISTING: 'GET_TRIMS_CREATE_GRN_LOT_LISTING',
  GET_FABRIC_CREATE_GRN_LOT_DETAILS: 'GET_CREATE_GRN_LOT_DETAILS',
  GET_TRIMS_CREATE_GRN_LOT_DETAILS: 'GET_CREATE_GRN_LOT_DETAILS',
  GENERATE_FABRIC_GRN_TAG: 'GENERATE_FABRIC_GRN_TAG',
  GENERATE_TRIMS_GRN_TAG: 'GENERATE_TRIMS_GRN_TAG',

  GET_FABRIC_STORAGE_GRN_DETAILS: 'GET_FABRIC_STORAGE_GRN_DETAILS',
  GET_TRIMS_STORAGE_GRN_DETAILS: 'GET_TRIMS_STORAGE_GRN_DETAILS',
  GET_FABRIC_STORAGE_ROLLS_DETAILS: 'GET_FABRIC_STORAGE_ROLLS_DETAILS',
  GET_TRIMS_STORAGE_ITEMS_DETAILS: 'GET_TRIMS_STORAGE_ITEMS_DETAILS',
  GET_LOCATION_DETAILS: 'GET_LOCATION_DETAILS',
  ADD_FABRIC_ROLLS_TO_STORAGE: 'ADD_FABRIC_ROLLS_TO_STORAGE',
  ADD_TRIM_ITEMS_TO_STORAGE: 'ADD_TRIM_ITEMS_TO_STORAGE',

  GET_MATERIAL_REQUEST_COUNTS: 'GET_MATERIAL_REQUEST_COUNTS',
  GET_WAREHOUSE_MATERIAL_REQUESTS: 'GET_WAREHOUSE_MATERIAL_REQUESTS',
  GET_FABRIC_ITEM_PENDING_MATERIAL_REQUEST_DETAILS: 'GET_FABRIC_ITEM_PENDING_MATERIAL_REQUEST_DETAILS',
  GET_TRIM_ITEM_PENDING_MATERIAL_REQUEST_DETAILS: 'GET_TRIM_ITEM_PENDING_MATERIAL_REQUEST_DETAILS',
  GET_FABRIC_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS: 'GET_FABRIC_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS',
  GET_TRIM_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS: 'GET_TRIM_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS',
  GET_ADDED_ROLLS_FOR_THE_SELECTED_ITEM_IN_COMPLETED_MATERIAL_REQUEST:
    'GET_ADDED_ROLLS_FOR_THE_SELECTED_ITEM_IN_COMPLETED_MATERIAL_REQUEST',
  GET_ROLL_DETAILS_FROM_ROLL_ID: 'GET_ROLL_DETAILS_FROM_ROLL_ID',
  GET_TRIM_PENDING_ITEM_DETAILS_WITH_SIZES: 'GET_TRIM_PENDING_ITEM_DETAILS_WITH_SIZES',
  GET_TRIM_COMPLETED_ITEM_DETAILS_WITH_SIZES: 'GET_TRIM_COMPLETED_ITEM_DETAILS_WITH_SIZES',
  ISSUE_SELECTED_MATERIAL: 'ISSUE_SELECTED_MATERIAL',

  GET_AVAILABLE_LOCATIONS_LISTING: 'GET_AVAILABLE_LOCATIONS_LISTING',
  GET_ITEMS_STORED_IN_LOCATION: 'GET_ITEMS_STORED_IN_LOCATION',
  GET_NEW_LOCATION_DETAILS: 'GET_NEW_LOCATION_DETAILS',
  CONFIRM_ITEMS_TRANSFER: 'CONFIRM_ITEMS_TRANSFER',
};

type TOrganizi8Endpoints = typeof Organizi8Endpoints;
type TOrganizi8EndpointsTypes = keyof TOrganizi8Endpoints;
type TEnvVariables = TOrganizi8Endpoints;

@Injectable({
  providedIn: 'root',
})
export class Organizi8EnvProvider {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private fabric_inspection_services = '';

  constructor(@Inject('environment') environment: TOrganizi8EnvironmentVars) {
    if (environment.protocol !== null) {
      this.protocol = environment.protocol;
    }
    if (environment.service_host !== null) {
      this.service_host = environment.service_host;
    }
    if (environment.fabric_inspection_services !== null) {
      this.fabric_inspection_services = environment.fabric_inspection_services;
    }
    this.registerVars();
  }

  registerVars() {
    const HOST = this.protocol + this.service_host;
    const FABRIC_INSPECTION_HOST = this.protocol + this.service_host + this.fabric_inspection_services;
    const baseURL = 'api/v1/wms';

    this.env_vars = {
      GET_FABRIC_CREATE_GRN_LOT_LISTING: `${FABRIC_INSPECTION_HOST}/${baseURL}/grn/lot/listing`,
      GET_TRIMS_CREATE_GRN_LOT_LISTING: `${FABRIC_INSPECTION_HOST}/${baseURL}/trimInspection/getLotListing`,
      GET_FABRIC_CREATE_GRN_LOT_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/grn/lot/details`,
      GET_TRIMS_CREATE_GRN_LOT_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/trimInspection/getLotDetails`,
      GENERATE_FABRIC_GRN_TAG: `${FABRIC_INSPECTION_HOST}/${baseURL}/grn/inspect`,
      GENERATE_TRIMS_GRN_TAG: `${FABRIC_INSPECTION_HOST}/${baseURL}/trimInspection/grn/generateTag`,

      GET_FABRIC_STORAGE_GRN_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/grn/lot/GRNDetails`,
      GET_TRIMS_STORAGE_GRN_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/trimInspection/getGRNDetails`,
      GET_FABRIC_STORAGE_ROLLS_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialStorage/fabricDetails`,
      GET_TRIMS_STORAGE_ITEMS_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialStorage/trimDetails`,
      GET_LOCATION_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/locations/getLocation`,
      ADD_FABRIC_ROLLS_TO_STORAGE: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialStorage/storeFabric`,
      ADD_TRIM_ITEMS_TO_STORAGE: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialStorage/storeTrims`,

      GET_MATERIAL_REQUEST_COUNTS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getMaterialRequestCounts`,
      GET_WAREHOUSE_MATERIAL_REQUESTS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getWarehouseMaterialRequests`,
      GET_FABRIC_ITEM_PENDING_MATERIAL_REQUEST_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getFabricMaterialRequestDetails`,
      GET_TRIM_ITEM_PENDING_MATERIAL_REQUEST_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getTrimMaterialRequestDetails`,
      GET_FABRIC_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getCompletedFabricMaterialRequestDetails`,
      GET_TRIM_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getCompletedTrimMaterialRequestDetails`,
      GET_ADDED_ROLLS_FOR_THE_SELECTED_ITEM_IN_COMPLETED_MATERIAL_REQUEST: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getCompletedRollWiseFabricMaterialRequestDetails`,
      GET_ROLL_DETAILS_FROM_ROLL_ID: `${FABRIC_INSPECTION_HOST}/${baseURL}/fabricInspection/grn/getFabricLotDetails`,
      GET_TRIM_PENDING_ITEM_DETAILS_WITH_SIZES: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getTrimMaterialRequestSizeWiseDetails`,
      GET_TRIM_COMPLETED_ITEM_DETAILS_WITH_SIZES: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/getCompletedTrimMaterialRequestSizeWiseDetails`,
      ISSUE_SELECTED_MATERIAL: `${FABRIC_INSPECTION_HOST}/${baseURL}/materialRequest/issueMaterial`,

      GET_AVAILABLE_LOCATIONS_LISTING: `${HOST}/${baseURL}`,
      GET_ITEMS_STORED_IN_LOCATION: `${HOST}/${baseURL}`,
      GET_NEW_LOCATION_DETAILS: `${HOST}/${baseURL}`,
      CONFIRM_ITEMS_TRANSFER: `${HOST}/${baseURL}`,
    };
  }

  getEnvVar(key: TOrganizi8EndpointsTypes): string {
    return this.env_vars[key];
  }
}
